import React from 'react';
import {
	AnalysisWrapper,
	FiltersWrapper,
	FlexCenterText,
	TableBody,
	TableCellChart,
	TableCellClassification,
	TableCellGroup,
	TableCellMax,
	TableCellMin,
	TableContainer,
	TableHead,
	TableRow,
} from './components/BenchmarkContainer.styles';
import ChartLegend from './components/ChartLegend/ChartLegend';
import CategoryHierarchy from './components/CategoryHierarchy/CategoryHierarchy';
import { SingleFilterWrapper } from 'SpendController/Components/Components.styles';
import MultiSelect from 'SpendController/Components/MultiSelect/MultiSelect';
import { useBenchmarkContext } from '../Contexts/BenchmarkProvider';
import {
	ApLoaderDefault,
	ApLoaderText,
	ApSimpleDropdown,
} from '@alixpartners/ui-components';

function BenchmarkVendorAnalysis() {
	const {
		breakDownFilters,
		vendorsData,
		currentBreakDownFilter,
		currentFilterOptions,
		currentFilterValuesSelected,
		setcurrentFilterValuesSelected,
		isLoading,
		handleFilterByChange,
	} = useBenchmarkContext();
	return (
		<div style={{ margin: '20px' }}>
			<FiltersWrapper>
				<ApSimpleDropdown
					label={`Filter By`}
					onChange={e => handleFilterByChange(e)}
					options={breakDownFilters}
					selected={breakDownFilters.find(
						e => e.value === currentBreakDownFilter.value
					)}
				/>
				<SingleFilterWrapper>
					<MultiSelect
						name={`${currentBreakDownFilter.label}`}
						label={`${currentBreakDownFilter.label}`}
						options={currentFilterOptions}
						selected={currentFilterValuesSelected}
						onChange={v => {
							setcurrentFilterValuesSelected(v);
						}}
					/>
				</SingleFilterWrapper>
				{/* <ApButtonMain
				style={{marginLeft:"50px"}}
							title="Apply Filter"
							iconName="filter_outlined"
							onClick={()=>{
								console.log("asdasdasd")
								applyVendorFilters()
							}}
						>
							Apply
						</ApButtonMain> */}
			</FiltersWrapper>
			{!isLoading ? (
				vendorsData.length > 0 ? (
					<AnalysisWrapper
						// isExpanded={hierarchyData[0].isExpanded}
						isExpanded={true}
						index="0"
						// isScroll={isAnyRevenueL1Expanded}
						isScroll={true}
					>
						<TableContainer>
							<TableHead>
								<TableRow>
									<TableCellGroup
										title="Vendor Name"
										showClassifications={true}
									>
										Vendor Name
									</TableCellGroup>
									<TableCellClassification title="L1">
										L1
									</TableCellClassification>
									<TableCellClassification title="L2">
										L2
									</TableCellClassification>
									<TableCellClassification title="L3">
										L3
									</TableCellClassification>
									<TableCellClassification title="L4">
										L4
									</TableCellClassification>
									<TableCellMin title="Peer Count" showClassifications={true}>
										Peer Count
									</TableCellMin>
									<TableCellMin
										title="Lower end of interquartile range"
										showClassifications={true}
									>
										Low End (days)
									</TableCellMin>
									<TableCellChart>
										<ChartLegend />
									</TableCellChart>
									<TableCellMax
										title="Higher end of interquartile range"
										showClassifications={true}
									>
										High End (days)
									</TableCellMax>
								</TableRow>
							</TableHead>
							<TableBody>
								<CategoryHierarchy
									data={vendorsData}
									showClassifications={true}
									showToggleButton={false}
								/>
							</TableBody>
						</TableContainer>
					</AnalysisWrapper>
				) : (
					<FlexCenterText>No data available</FlexCenterText>
				)
			) : (
				<ApLoaderDefault loaderText={() => <ApLoaderText />} />
			)}
		</div>
	);
}

export default BenchmarkVendorAnalysis;
